import { Typography } from 'antd'
import React, { FC, ReactElement, useState } from 'react'
import AnimateHeight from 'react-animate-height'
import { useTranslation } from 'react-i18next'
import { ExpandCollapseChevronButton } from '../../../../../Components/UI'
import { ProposalCard } from '../ProposalCard/ProposalCard'
import { ProposalsEventFragment, ProposalsProposalFragment } from './Proposals.generated-types'
import { s } from './style'

const { Text } = Typography

interface ProposalsProps {
  event: ProposalsEventFragment
  defaultExpanded?: boolean
  refetchEvent: () => void
}

export const Proposals: FC<ProposalsProps> = ({
  event,
  event: { proposals },
  defaultExpanded,
  refetchEvent,
}): ReactElement => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(defaultExpanded)

  const handleExpandCollapse = (): void => setExpanded(!expanded)

  return (
    <>
      <div style={s.wrapper}>
        <AnimateHeight
          duration={Math.min(proposals.length * 250, 1000)}
          height={expanded ? 'auto' : 90 + 8 * proposals.length}>
          <div style={s.root}>
            {getDisplayOrderOfEventProposals(event).map((proposal, index) => (
              <ProposalCard
                event={event}
                refetchEvent={refetchEvent}
                proposal={proposal}
                expanded={expanded}
                handleExpandCollapse={handleExpandCollapse}
                responseIndex={index}
                key={proposal.UUID}
              />
            ))}
          </div>
        </AnimateHeight>
      </div>
      {!defaultExpanded && expanded && (
        <div style={s.collapsed}>
          <ExpandCollapseChevronButton
            expanded={expanded}
            handleExpandCollapse={handleExpandCollapse}
          />
          <Text strong>
            {t('eventHub.inProgress.responses.hideOthers', 'Hide other responses')}
          </Text>
        </div>
      )}
    </>
  )
}

const getDisplayOrderOfEventProposals = (
  event: ProposalsEventFragment
): ProposalsProposalFragment[] => {
  return event.proposals
    .filter((p) => p.status === 'SentToGuest')
    .sort(
      (proposalA: ProposalsProposalFragment, proposalB: ProposalsProposalFragment) =>
        Number(proposalB.hasPreferredVenue) - Number(proposalA.hasPreferredVenue)
    )
}
